export default __webpack_public_path__ + "static/features-phone-immersion-c3bafbacf7337fd536859b79db6082d7.png";